<template>
    <div class="px-8">
        <form-header title="Device">
        </form-header>

        <TabBar class="py-4" v-model="currentTab" :tabs="tabs" />

        <div v-show="currentTab === 0">
            <form-select id="deviceModel" type="text" label="Model" :error="msg.modelId" v-model.trim="localCopy.modelId" :options="models">
                <button @click="onClickDeviceModel" class="bg-white rounded-r-md w-10 border-gray-300 border -ml-1 pl-2 text-gray-500">
                    <ExternalLinkIcon class="w-4 h-4"/>
                </button>
            </form-select>

            <form-input id="serial" type="text" label="Serial No" :error="msg.serial" v-model.trim="localCopy.serial"/>
            <form-toggle id="warrantyvalid" label="Warranty Valid" v-model="localCopy.warrantyValid"/>
            <form-toggle id="mcsAccredited" label="Installation is MCS Accredited" v-model="localCopy.mcsAccredited" readonly="true"/>

            <h4 class="text-md font-medium pt-6">Purchase Information</h4>
            <form-input id="model" type="text" label="Model (User Entered)" :error="msg.model" v-model.trim="localCopy.model"/>
            <form-select id="companyId" type="text" label="Purchasing Company" v-model.trim="localCopy.companyId" :options="companies"/>
            <form-select id="customerId" type="text" label="Customer" v-model.trim="localCopy.customerId" :options="companies"/>
            <form-select id="pointsAssignedId" type="text" label="Points Assigned To" v-model.trim="localCopy.pointsCompanyId" :options="companies"/>
            <form-input id="date" type="text" label="Date" :error="msg.date" readonly="true" :modelValue="momentDate(localCopy.date)"/>
            <form-input id="job_ref" type="text" label="Customer Ref" :error="msg.job_ref" v-model.trim="localCopy.job_ref"/>
            <div v-if="localCopy.DeviceModel && localCopy.DeviceModel.isHeatPump">
                <form-div  label="Installation Address">
                    <textarea @input="updated" class="h-24 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm text-gray-700" v-model.trim="localCopy.address">
                    </textarea>
                    <div v-if="msg.address" class="max-w-lg sm:max-w-xs">
                        <p class="mt-2 text-sm text-red-600" :id="id+'-error'">{{ msg.address }}</p>
                    </div>
                </form-div>

                <form-input id="installationPostcode" type="text" label="Installation Postcode" :error="msg.postcode" v-model.trim="localCopy.postcode"/>
                <form-input id="homeownerPhone" type="text" label="Homeowner Telephone" :error="msg.homeownerPhone" v-model.trim="localCopy.homeownerPhone"/>
                <form-input id="homeownerName" type="text" label="Homeowner Name" :error="msg.homeownerName" v-model.trim="localCopy.homeownerName"/>
                <form-input id="policyNumber" type="text" label="Policy Number" :error="msg.policyNumber" v-model.trim="localCopy.policyNumber"/>
                <form-toggle id="micarePolicyActive" label="Mi Care Policy Active" v-model="localCopy.micarePolicyActive"/>
                <form-toggle id="installerPolicyActive" label="Installer Policy Active" v-model="localCopy.installerPolicyActive"/>
            </div>

            <form-input v-if="localCopy.installerSupported" id="installerCompanyName" type="text" label="Company Name (User Entered)" v-model.trim="localCopy.installerCompanyName" redonly="true"/>
            <form-input v-if="localCopy.installerSupported" id="installerCompanyEmail" type="text" label="Company Email (User Entered)" v-model.trim="localCopy.installerCompanyEmail" redonly="true"/>

            <h4 class="text-md font-medium pt-6">Mi Care Points</h4>
            <div v-if="localCopy.warrantyRegistered">
                <form-toggle id="inVault" label="Store points in vault" v-model="localCopy.miCarePointsInVault"/>
                <form-input id="miCarePointsEarned" type="number" label="Points Earned" :error="msg.miCarePoints" v-model.trim="localCopy.miCarePoints">
                    <div v-if="localCopy.miCarePointsInVault" class="absolute right-0 top-0 bottom-0 border-t border-r border-b border-gray-300 bg-blue-50 text-blue-800 font-bold px-4 rounded-r-md pt-1 pb-0.5 text-xs inline-flex gap-1 items-center">
                        <LockClosedIcon class="w-4 h-4 -mt-0.5"/>
                        VAULT
                    </div>
                </form-input>
                <form-input id="miCarePointsUsed" type="number" label="Points Used" :error="msg.spentMiCarePoints" v-model.trim="localCopy.spentMiCarePoints" readonly/>
                <form-date id="miCareExpiry" type="text" label="Points Expiry Date" v-model="localCopy.miCareExpiry"/>
            </div>


            <h4 class="text-md font-medium pt-6">Warranty Information</h4>
            <form-toggle id="noAccessToSite" label="Limited access to site" v-model="localCopy.noAccessToSite" readonly="true"/>
            <form-toggle id="warrantyRegistered" label="Product Has Been Registered" v-model="localCopy.warrantyRegistered"/>
            <form-input id="warrantyEmail" type="text" label="Warranty Email" :error="msg.warrantyEmail" v-model.trim="localCopy.warrantyEmail"/>
            <form-date v-if="localCopy.warrantyRegistered" id="warrantyDate" type="text" label="Warranty Registration Date" v-model="localCopy.warrantyRegistrationDate"/>
            <form-date v-if="localCopy.warrantyRegistered" id="warrantyExpDate" type="text" label="Warranty Expiry Date" v-model="localCopy.warrantyExpiryDate"/>
            <form-input v-if="!localCopy.warrantyRegistered" id="warrantyDate" type="text" label="Warranty Registration Date" :modelValue="'Not registered'" readonly="true"/>
            <form-input v-if="localCopy.warrantyRegistered" id="serviceYear" type="text" label="Warranty Service Year" :modelValue="localCopy.serviceYear" readonly="true"/>

            <h4 class="pt-4 text-md font-medium">Unrestricted Verifications</h4>
            <p class="text-sm text-gray-400 max-w-sm"><b>Only enable this for demo users.</b> If this is turned on then user will be allowed to register the same device multiple times without resstriction.</p>
            <form-toggle id="unrestrictedRegistrations" label="Unrestricted Registrations" v-model="localCopy.unrestrictedRegistrations"/>

            <div v-if="localCopy?.DeviceModel?.isHeatPump">
                <h4 class="pt-4 text-md font-medium">Homeowner Signature</h4>
                <div v-if="!localCopy.homeownerSignatures || localCopy.homeownerSignatures.length ===0" class="mt-1 max-w-2xl text-sm text-gray-500">There are no homeowner signatures associated to this device.</div>
                <form-image v-else id="Signatures" label="Signatures" :images="localCopy.homeownerSignatures"/>

                <h4 class="pt-4 text-md font-medium">Installer Signature</h4>
                <div v-if="!localCopy.installerSignatures || localCopy.installerSignatures.length ===0" class="mt-1 max-w-2xl text-sm text-gray-500">There are no installer signatures associated to this device.</div>
                <form-image v-else id="Signatures" label="Signatures" :images="localCopy.installerSignatures"/>
            </div>

            <form-div v-if="changed" class="pt-2">
                <custom-button type="primary" @click="save" class="w-24 mr-2">Save</custom-button>
                <custom-button type="white" @click="cancel" class="w-24">Cancel</custom-button>
            </form-div>

            <h4 class="text-md font-medium pt-6">Service History</h4>
            <form-table v-if="hasServiceHistory" :data="serviceHistoryTable" class="pt-4"/>
            <div v-if="!hasServiceHistory" class="mt-1 max-w-2xl text-sm text-gray-500">There is no service history associated to this device.</div>
        </div>

        <div v-show="currentTab === 1">
            <form-input id="partDeviceSerial" type="text" label="Serial" :error="sparePartError.serial" readonly="true" :modelValue="sparePartCopy.serial"/>
            <div v-for="part, idx in sparePartCopy.partDetails" :key="idx">
                <form-input id="partDetail" class="relative" type="text" label="Part Description" :error="sparePartError.partDetail" v-model="part.description">
                    <div @click="() => removePartDetail(idx)" v-if="idx > 0" class="self-center absolute -right-4 text-gray-400 transition hover:text-gray-700 cursor-pointer">x</div>
                </form-input>

                <form-input class="relative" id="partCode" type="text" label="Part Code" :error="sparePartError.partDetail" v-model="part.code">
                    <custom-button v-if="idx === sparePartCopy.partDetails.length - 1" type="white" @click="addMoreParts" class="ml-2 absolute -right-36">Add more parts</custom-button>
                </form-input>
            </div>

            <form-input id="partCompanyName" type="text" label="Company Name" :error="sparePartError.companyName" v-model="sparePartCopy.companyName"/>
            <form-input id="partContactName" type="text" label="Contact Name" :error="sparePartError.contactName" v-model="sparePartCopy.contactName"/>
            <form-div v-if="sparePartChanged" class="pt-2">
                <custom-button type="primary" @click="logSparePart" class="mr-2">Log spare part</custom-button>
                <custom-button type="white" @click="resetSparePart" class="w-24">Cancel</custom-button>
            </form-div>
            <div v-if="!sparePartChanged && sparePartLogged" class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-2">
                <p class="col-start-2 mt-2 text-sm text-blue-700">Spare part logged successfully.</p>
            </div>
        </div>
    </div>
</template>

<script>
import FormHeader from '../components/FormHeader.vue'
import FormSelect from '../components/FormSelect.vue'
import FormDiv from '../components/FormDiv.vue'
import FormInput from '../components/FormInput.vue'
import FormDate from '../components/FormDate.vue'
import FormToggle from '../components/FormToggle.vue'
import FormTable from '../components/FormTable.vue'
import FormImage from '../components/FormImage.vue'
import CustomButton from '../components/CustomButton.vue'
import { ExternalLinkIcon } from '@heroicons/vue/outline';
import { LockClosedIcon } from '@heroicons/vue/solid';
import TabBar from '../components/TabBar.vue'

import _ from 'lodash';

export default {
    components: { FormHeader, FormInput, FormDate, FormToggle, FormDiv, FormTable, FormSelect, FormImage, CustomButton, ExternalLinkIcon, LockClosedIcon, TabBar },
    data: function() {
        return {
            changed: false,
            data: {},
            localCopy: {},
            msg: {},
            images: [],
            serviceHistory: [],
            models: [],
            companies: [],
            tabs: [
                { id: 0, name: 'Details'},
                { id: 1, name: 'Log a Spare Part'}
            ],
            currentTab: 0,
            sparePartDefault: {
                id: -1,
                partDetails: [{ description: '', code: '' }],
                contactName: '',
                companyName: '',
                serial: '',
            },
            sparePartCopy: {},
            sparePartError: {},
            sparePartChanged: false,
            sparePartLogged: false,
        }
    },
    computed: {
        serviceHistoryTable: function() {
            let table = {}
            table.rows = []
            for (let svc of this.serviceHistory) {
                table.rows.push({
                    date: this.momentDate(svc.date),
                    type: svc.type,
                    approved: (svc.type != 'warranty' && svc.type != 'service') ? '✔️' : svc.approved ? '✔️' : '❌',
                    link: '/registration/' + svc.id
                })
            }
            table.keys = [
                { title: 'Date', key:'date' },
                { title: 'Type', key:'type' },
                { title: 'Approved', key: 'approved' } 
            ]
            return table
        },
        hasServiceHistory: function() {
            return this.serviceHistory.length > 0
        }
    },
    props: [
        'id',
        'prev'
    ],
    methods: {
        async refreshData() {
            let query = await this.axios.get(`/device/${this.id}`)
            this.data = query.data
            this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.data)), this.data)
        },
        validate: function() {
            this.msg = {}

            var constraints = {
                serial: {
                    presence: true,
                },
                modelId: {
                    presence: true,
                    numericality: { onlyInteger: true, greaterThan: 0 }
                },
                warrantyEmail: {
                    email: true
                }
            };

            this.msg = this.$validate(this.localCopy, constraints) || {}
            if (this.creating) {
                if (!this.msg.password && this.localCopy.password != this.localCopy.password2) { this.msg.password2 = 'Passwords must match' }
            }

            if (this.localCopy.micarePolicyActive) {
                if (!this.localCopy.address?.trim()) { this.msg.address = 'Activating Mi Care policy requires installation address' }
                if (!this.localCopy.homeownerName?.trim()) { this.msg.homeownerName = 'Activating Mi Care policy requires homeowner name' }
                if (!this.localCopy.policyNumber?.trim()) { this.msg.policyNumber = 'Activating Mi Care policy requires policy number' }
                if (!this.localCopy.warrantyEmail?.trim()) { this.msg.warrantyEmail = 'Activating Mi Care policy requires warranty email' }
            }

            return Object.keys(this.msg).length == 0
        },
        onClickDeviceModel: function() {
            this.$router.push(`/devicemodel/${this.localCopy.modelId}`)
        },
        save: async function() {
            if (this.validate()) {
                try {
                    await this.axios.post('/device/update', this.localCopy)
                    this.data = Object.assign(Object.create(Object.getPrototypeOf(this.localCopy)), this.localCopy)
                    this.changed = false
                }
                catch (error) {
                    if (error && error.response && error.response.data && error.response.data.msg) {
                        this.msg = error.response.data.msg
                    }
                }
            }
        },
        cancel: function() {
            this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.data)), this.data)
            this.changed = false
        }, 
        updated: function() {
            const newVal = !_.isEqual(this.localCopy, this.data)
            if (this.changed != newVal) {
                this.changed = newVal;
            }
        },
        validateSparePart: function() {
            this.sparePartError = {}

            const constraints = {
                contactName: { presence: true, length: { minimum: 1 } },
                companyName: { presence: true, length: { minimum: 1 } },
            };

            this.sparePartError = this.$validate(this.sparePartCopy, constraints) || {}

            return Object.keys(this.sparePartError).length == 0
        },
        logSparePart: async function() {
            if (this.validateSparePart()) {
                try {
                    await this.axios.post('/device/logSpare', this.sparePartCopy)
                    
                    this.resetSparePart()
                    this.sparePartLogged = true

                    const query = await this.axios.get(`/registration?limit=50&device=${this.id}`) 
                    this.serviceHistory = query.data.items
                }
                catch (error) {
                    if (error && error.response && error.response.data && error.response.data.msg) {
                        this.sparePartError = error.response.data.msg
                    }
                }
            }
        },
        resetSparePart: function() {
            this.sparePartDefault.id = this.data.id
            this.sparePartDefault.serial = this.data.serial

            this.sparePartCopy = _.cloneDeep(this.sparePartDefault)
            this.sparePartChanged = false
            this.sparePartError = {}
        },
        addMoreParts: function() {
            this.sparePartCopy.partDetails.push({ description: '', code: '' })
        },
        removePartDetail: function(idx) {
            this.sparePartCopy.partDetails.splice(idx, 1)
        }
    },
    mounted: async function() {
        let query = await this.axios.get(`/deviceModel/all`)
        this.models = query.data

        query = await this.axios.get(`/company/all`)
        this.companies = query.data

        query = await this.axios.get(`/device/${this.id}`)
        this.data = query.data
        this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.data)), this.data)

        this.resetSparePart()

        query = await this.axios.get(`/registration?limit=50&device=${this.id}`) 
        this.serviceHistory = query.data.items
    },
    updated: function() {
        const newVal = !_.isEqual(this.localCopy, this.data)
        if (newVal) {
            this.sparePartDefault.serial = this.localCopy.serial
            this.sparePartCopy.serial = this.localCopy.serial
        }
        if (this.changed != newVal) {
            this.changed = newVal;
        }

        const newSparePart = !_.isEqual(this.sparePartCopy, this.sparePartDefault)
        if (this.sparePartChanged != newSparePart) {
            this.sparePartChanged = newSparePart
            this.sparePartLogged = false
        }
    },
}
</script>